import React from "react";

import ApplicantsListView from "./ApplicantsListView";
import useApplicantsList from "./hooks/useApplicantsList";

import "./Applicants.scss";

const Applicants = () => {
  const viewProps = useApplicantsList();

  return <ApplicantsListView {...viewProps} />;
};

export default Applicants;
